import ListViewCtrl from "../util/ListViewCtrl";

export default class KontaktImportListCtrl extends ListViewCtrl {

  static $inject = ["itemSource", "KontaktService"];
  constructor(itemSource, KontaktService){
    super(itemSource);
    this.selection = {};
    this.KontaktService = KontaktService;
  }

  selectedIds(){
    return Object.keys(this.selection).filter(k => this.selection[k]);
  }

  clearSelection(){
    this.selection = {};
    this.isAllSelected = false;
  }

  toggleSelection(){
    if(this.isAllSelected){
      this.clearSelection();
    }else{
      this.itemSource.result.map(item => item.id).forEach(id => this.selection[id] = true);
      this.isAllSelected = true;
    }
  }

  importSelected(){
    this.KontaktService.importConfirm(this.selectedIds())
      .then(() => this.itemSource.load())
      .then(() => this.clearSelection());
  }

  cancelSelected(){
    this.KontaktService.importCancel(this.selectedIds())
      .then(() => this.itemSource.load())
      .then(() => this.clearSelection());
  }


}


// WEBPACK FOOTER //
// ./src/Kontakt/KontaktImportListCtrl.js